const contactForm = document.querySelector('.contact-form');

if (contactForm) {
    const formTriggerActiveClass = 'contact-form__nav-item--active';
    const formActiveClass = 'contact-form__single--active';
    const formTriggers = document.querySelectorAll('.contact-form__nav-item');
    const handleFormTriggerClick = (event) => {
      const _this = event.currentTarget;
      const targetForm = _this.dataset.formTarget;

      if (_this.classList.contains(formTriggerActiveClass)) {
        return;
      }

      const formsEls = document.querySelectorAll('.contact-form__single');
      const targetFormEl = document.querySelector(`[data-form-id="${targetForm}"]`);

      formsEls.forEach((form) => form.classList.remove(formActiveClass));
      targetFormEl.classList.add(formActiveClass);

      // This is needed because the iframed forms will not have the correct height if they are not visible when the page loads
      if (targetFormEl instanceof HTMLElement) {
        const iframeCode = targetFormEl.dataset.formIframeCode;
        if (iframeCode) {
          const contentElem = targetFormEl.querySelector('.container');
          contentElem.innerHTML = iframeCode;
        }
      }

      formTriggers.forEach((trigger) => trigger.classList.remove(formTriggerActiveClass));
      _this.classList.add(formTriggerActiveClass);
    };

    formTriggers.forEach((trigger) => trigger.addEventListener('click', handleFormTriggerClick));
}

